import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';

import { wrapFetch } from 'util/api';

export const getNews = createAction('GET_NEWS', async () => {
	const { status, data } = await wrapFetch('news');

	if (status !== 200) {
		return { data: {}, list: [] };
	}

	const newsData = {};
	const list = data.map(item => {
		newsData[item.id] = item;

		return item.id;
	});

	return { data: newsData, list };
});

export const defaultNewsData = {
	id: 1,
	title: '',
	image:
		'https://member-yuanyu.25demo.com/backstage/upload/news/20190220-e47c4501881961ff44cff69421ef6461.jpg',
	intro: '',
	url: '',
};

const reducer = {
	news: handleActions(
		{
			GET_NEWS_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_NEWS_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
				list: action.payload.list,
				loading: false,
			}),
		},
		{
			data: {},
			list: [],
			loading: false,
		},
	),
};

const mapHooksToStateByTotal = createSelector(
	state => state.news.list,
	list => list,
);

export const useTotalNews = () => useRedux(mapHooksToStateByTotal);

const mapHooksToState = createSelector(
	(state, id) => state.news.data[id] || defaultNewsData,
	data => data,
);

export const useNews = id => useRedux(state => mapHooksToState(state, id));

export default { reducer };
